@if (!isStyleModern) {
    <mat-form-field class="mat-custom" [ngClass]="fixMargin ? 'mat-fix-padding' : ''" appearance="fill">
        <mat-label>{{ 'shared.miscellaneous.search-dots' | translate }}</mat-label>
        <input [ngModel]="filter" (ngModelChange)="onFilterChange($event)" matInput />
        @if (dataSource?.filter) {
            <button (click)="resetFilter()" aria-label="Clear" mat-icon-button matSuffix>
                <i class="material-icons">close</i>
            </button>
        }
    </mat-form-field>
} @else {
    <input
        type="search"
        [ngModel]="filter"
        (ngModelChange)="onFilterChange($event)"
        placeholder="{{ 'shared.miscellaneous.search-dots' | translate }}"
    />
    <mat-icon class="icon">search</mat-icon>
}
